<template>
    <b-card>
      <b-table responsive="sm" :items="managers" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="padding-bottom:0px;">
        <template slot="name" slot-scope="data">
          <div class="avatar">
            <img class="img-avatar" :src="data.item.avatar" :alt="data.item.email" style="margin-left:10px; height:35px;" v-if="data.item.avatar">
            <img src="https://static.wixstatic.com/media/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png/v1/fill/w_63,h_64,al_c,usm_0.66_1.00_0.01/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png" border="0" style="float:left; height:35px; margin:10px;" v-if="(data.item.avatar == '' || data.item.avatar == null)">
            <span class="avatar-status badge-success" style="position: absolute;left: 5px;top: 10px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) > 25"></span>
            <span class="avatar-status badge-warning" style="position: absolute;left: 5px;top: 10px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) > 5 && percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) < 25"></span>
            <span class="avatar-status badge-danger" style="position: absolute;left: 5px;top: 10px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) < 5"></span>
          </div>
        </template>
<template slot="activeDate" slot-scope="data">
          <small class="text-muted ng-binding">
          <i class="icon-calendar"></i>  {{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
          </small>
          <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) < 0" style="color:red !important;">
            <strong> - </strong> {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
          </small>
           <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) > 0">
              <strong> - </strong> {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
            </small>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) > 25">
            <div class="progress-bar bg-success" role="progressbar" :style="percentage(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime())" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) < 25 && percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) > 5">
            <div class="progress-bar bg-warning" role="progressbar" :style="percentage(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime())" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="percentageVal(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime()) <= 5">
            <div class="progress-bar bg-danger" role="progressbar" :style="percentage(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime())" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </template>
<template slot="contact" slot-scope="data">
          <i class="icon-user" v-if="(data.item.user.gender == 'male' || data.item.user.gender == null)"></i>
          <i class="icon-user-female" v-if="data.item.user.gender == 'female'"></i>
          {{data.item.name}} |
          <i class="icon-phone"></i> {{data.item.phone}}
          <a :href="whatsapp(data.item.phone)" :target="data.item.phone"><i class="fa fa-whatsapp"></i></a>
          <!-- <i class="fa fa-telegram"></i>
          <i class="fa fa-instagram"></i> -->
          <br/>
           <i class="icon-envelope"></i> <a :href="mailto(data.item.email)">{{data.item.email}}</a>
        </template>
<template slot="action" slot-scope="data">
          <div style="width:245px; float:right;">
            <b-button type="button" variant="primary" @click.stop="showModal(modalassign(data.item.lockManagerId), $event.target)" ok-only ok-variant="secondary" ok-title="Cancel" style="float:left;" v-if="new Date(data.item.endDate).getTime() > new Date().getTime()">
              <i class="fa fa-plus-circle"></i>
              Assign
            </b-button>

            <b-button type="button" variant="danger" @click.stop="showModal(modalDeleteId(data.item.lockManagerId), $event.target)"  style="float: right; position: relative;" v-if="new Date(data.item.endDate).getTime() > new Date().getTime()">
              <i class="fa fa-trash-o"></i>
              Delete
            </b-button>

            <b-button type="button" variant="primary"  @click.stop="showModal(modalId(data.item.lockManagerId), $event.target)" style="float:right; margin-right:5px;">
              <i class="fa fa-edit"></i>
              Edit
            </b-button>
          </div>
        </template>
</b-table>
<nav>
  <b-pagination :total-rows="getRowCount(managers)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
</nav>

<div v-for="manager in managers" :key="manager.id">
  <b-modal ok-only ok-variant="secondary" ok-title="Cancel" :id="modalId(manager.lockManagerId)" size="lg" centered>
    <manager-edit-form :managerId=manager.lockManagerId :modalId="modalId(manager.lockManagerId)"></manager-edit-form>
  </b-modal>

  <b-modal :id="modalDeleteId(manager.lockManagerId)" @ok="handleOk(manager.lockManagerId, modalDeleteId(manager.lockManagerId), $event.target)" centered>
    <div class="modal-window">
      <div class="alert alert-danger">
        <ul class="fa-ul" style="margin-bottom: 0px;">
          <li>
            <i class="fa fa-info-circle fa-li"></i>
            <p>Are you sure you want to delete manager:<br/> <strong>{{ manager.name }}</strong> ?</p>
          </li>
        </ul>
      </div>
    </div>
  </b-modal>

  <b-modal :id="modalassign(manager.lockManagerId)" size="lg" centered>
    <manager-assign :managerId=manager.lockManagerId :modalId="modalassign(manager.lockManagerId)"></manager-assign>
    <div slot="modal-footer" class="w-100">
    </div>
  </b-modal>
</div>
</b-card>
</template>

<script>
import ManagerEditForm from '@/views/base/haus/ManagerEditForm'
import ManagerAssign from '@/views/base/haus/ManagerAssign'
let qs = require('qs')

const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/list'
const API_DELETE = BASE + '/api/lockManagers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdata(API, parameters)
  return res.lockManagers
}

async function deleteManager (managerId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    managerId: managerId
  }
  let res = await postdata(API_DELETE, parameters)
  return res
}

export default {
  name: 'manager-list',
  components: {
    ManagerEditForm,
    ManagerAssign
  },
  props: ['locationName', 'locationDescription'],
  data: () => {
    return {
      managers: [],
      fields: {
        name: {
          label: '<i class="icon-user progress-group-icon"></i>'
        },
        contact: {
          label: '<i class="icon-globe"></i>'
        },
        activeDate: {
          label: '<i class="icon-calendar"></i>'
        },
        action: {
          label: '<i class="icon-menu"></i>'
        }
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData().then(response => {
      this.$data.managers = response
      this.$root.$on('managers', (dataManagers) => {
        this.managers = dataManagers
      })
    })
  },
  methods: {

    modalassign (i) {
      return 'modalassign' + i
    },
    modalId (i) {
      return 'modal' + i
    },
    modalDeleteId (i) {
      return 'modaldeletemanager' + i
    },
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    handleOk (managerId, modalId, button) {
      deleteManager(managerId).then(deleteManager => {
        getData().then(response => {
          this.$root.$emit('managers', response)
          this.$root.$emit('bv::hide::modal', modalId, button)
        })
      })
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    },
    percentage (startDate, endDate) {
      let percentageVal = this.percentageVal(startDate, endDate)
      let val = 'width: ' + percentageVal + '%'
      return val
    },
    percentageVal (startDate, endDate) {
      let currtimestamp = new Date()
      let total = endDate - startDate
      let currentCount = currtimestamp.getTime() - startDate
      let percentage = 100 - ((currentCount * 100) / total)
      return percentage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/ManagerList.vue